import Preloader from "components/Preloader"
import Transition from "components/Transition"
import { useBackButton } from "library/Loader/TransitionUtils"
import Scroll from "library/Scroll"
import { useTrackPageReady } from "library/pageReady"
import useTrackFrameTime from "library/useTrackFrameTime"
import styled, { createGlobalStyle, css } from "styled-components"
import { ColorStyle } from "styles/colors"
import colors from "styles/colors"
import textStyles from "styles/text"
import Footer from "./Footer"
import Header from "./Header"
import RegsitryModal from "./RegistryModal"
import RsvpModal from "./RsvpModal"
import VenmoModal from "./VenmoModal"

interface LayoutProps {
	children: React.ReactNode
}

export default function Layout({ children }: LayoutProps) {
	useTrackPageReady()
	useBackButton()
	useTrackFrameTime()

	return (
		<>
			<Transition />
			<Preloader />
			<GlobalStyle />
			<ColorStyle />
			<RsvpModal />
			<VenmoModal />
			<RegsitryModal />
			<Scroll>
				<Header />
				<Main>{children}</Main>
				<Footer />
			</Scroll>
		</>
	)
}

const Main = styled.main`
	overflow-x: clip;
	background-color: ${colors.rose05};
`

const globalCss = css`
	/* default text styles */
	html {
		/* if your project uses a dark color for most text, set that here */
		color: ${colors.rose02};
		${textStyles.body}
	}

	* {
		/* need this so that fonts match figma */
		text-rendering: geometricprecision;
		-webkit-font-smoothing: antialiased;
	}

	/** restore default focus states for elements that need them */
	*:focus-visible {
		outline: 2px solid #00f8;
	}
`

const GlobalStyle = createGlobalStyle`${globalCss}`
